export default __webpack_public_path__ + "static/media/Brigand's Legguards of the Khan.01f25591.jpg";